/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as PublicRouteRouteImport } from './routes/_public/route'
import { Route as PrivateRouteRouteImport } from './routes/_private/route'
import { Route as PublicAuthRouteRouteImport } from './routes/_public/auth/route'
import { Route as PrivateWelcomeRouteRouteImport } from './routes/_private/welcome/route'
import { Route as PrivateHomeRouteRouteImport } from './routes/_private/_home/route'
import { Route as PublicAuthIndexRouteImport } from './routes/_public/auth/index'
import { Route as PrivateHomeIndexRouteImport } from './routes/_private/_home/index'
import { Route as PrivateWelcomePartnerIdRouteImport } from './routes/_private/welcome/$partnerId'

const PublicRouteRoute = PublicRouteRouteImport.update({
  id: '/_public',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivateRouteRoute = PrivateRouteRouteImport.update({
  id: '/_private',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicAuthRouteRoute = PublicAuthRouteRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => PublicRouteRoute,
} as any)
const PrivateWelcomeRouteRoute = PrivateWelcomeRouteRouteImport.update({
  id: '/welcome',
  path: '/welcome',
  getParentRoute: () => PrivateRouteRoute,
} as any)
const PrivateHomeRouteRoute = PrivateHomeRouteRouteImport.update({
  id: '/_home',
  getParentRoute: () => PrivateRouteRoute,
} as any)
const PublicAuthIndexRoute = PublicAuthIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PublicAuthRouteRoute,
} as any)
const PrivateHomeIndexRoute = PrivateHomeIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PrivateHomeRouteRoute,
} as any)
const PrivateWelcomePartnerIdRoute = PrivateWelcomePartnerIdRouteImport.update({
  id: '/$partnerId',
  path: '/$partnerId',
  getParentRoute: () => PrivateWelcomeRouteRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof PrivateHomeIndexRoute
  '/welcome': typeof PrivateWelcomeRouteRouteWithChildren
  '/auth': typeof PublicAuthRouteRouteWithChildren
  '/welcome/$partnerId': typeof PrivateWelcomePartnerIdRoute
  '/auth/': typeof PublicAuthIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof PrivateHomeIndexRoute
  '/welcome': typeof PrivateWelcomeRouteRouteWithChildren
  '/welcome/$partnerId': typeof PrivateWelcomePartnerIdRoute
  '/auth': typeof PublicAuthIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_private': typeof PrivateRouteRouteWithChildren
  '/_public': typeof PublicRouteRouteWithChildren
  '/_private/_home': typeof PrivateHomeRouteRouteWithChildren
  '/_private/welcome': typeof PrivateWelcomeRouteRouteWithChildren
  '/_public/auth': typeof PublicAuthRouteRouteWithChildren
  '/_private/welcome/$partnerId': typeof PrivateWelcomePartnerIdRoute
  '/_private/_home/': typeof PrivateHomeIndexRoute
  '/_public/auth/': typeof PublicAuthIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/welcome' | '/auth' | '/welcome/$partnerId' | '/auth/'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/welcome' | '/welcome/$partnerId' | '/auth'
  id:
    | '__root__'
    | '/_private'
    | '/_public'
    | '/_private/_home'
    | '/_private/welcome'
    | '/_public/auth'
    | '/_private/welcome/$partnerId'
    | '/_private/_home/'
    | '/_public/auth/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  PrivateRouteRoute: typeof PrivateRouteRouteWithChildren
  PublicRouteRoute: typeof PublicRouteRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PublicRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_private': {
      id: '/_private'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PrivateRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public/auth': {
      id: '/_public/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof PublicAuthRouteRouteImport
      parentRoute: typeof PublicRouteRoute
    }
    '/_private/welcome': {
      id: '/_private/welcome'
      path: '/welcome'
      fullPath: '/welcome'
      preLoaderRoute: typeof PrivateWelcomeRouteRouteImport
      parentRoute: typeof PrivateRouteRoute
    }
    '/_private/_home': {
      id: '/_private/_home'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PrivateHomeRouteRouteImport
      parentRoute: typeof PrivateRouteRoute
    }
    '/_public/auth/': {
      id: '/_public/auth/'
      path: '/'
      fullPath: '/auth/'
      preLoaderRoute: typeof PublicAuthIndexRouteImport
      parentRoute: typeof PublicAuthRouteRoute
    }
    '/_private/_home/': {
      id: '/_private/_home/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof PrivateHomeIndexRouteImport
      parentRoute: typeof PrivateHomeRouteRoute
    }
    '/_private/welcome/$partnerId': {
      id: '/_private/welcome/$partnerId'
      path: '/$partnerId'
      fullPath: '/welcome/$partnerId'
      preLoaderRoute: typeof PrivateWelcomePartnerIdRouteImport
      parentRoute: typeof PrivateWelcomeRouteRoute
    }
  }
}

interface PrivateHomeRouteRouteChildren {
  PrivateHomeIndexRoute: typeof PrivateHomeIndexRoute
}

const PrivateHomeRouteRouteChildren: PrivateHomeRouteRouteChildren = {
  PrivateHomeIndexRoute: PrivateHomeIndexRoute,
}

const PrivateHomeRouteRouteWithChildren =
  PrivateHomeRouteRoute._addFileChildren(PrivateHomeRouteRouteChildren)

interface PrivateWelcomeRouteRouteChildren {
  PrivateWelcomePartnerIdRoute: typeof PrivateWelcomePartnerIdRoute
}

const PrivateWelcomeRouteRouteChildren: PrivateWelcomeRouteRouteChildren = {
  PrivateWelcomePartnerIdRoute: PrivateWelcomePartnerIdRoute,
}

const PrivateWelcomeRouteRouteWithChildren =
  PrivateWelcomeRouteRoute._addFileChildren(PrivateWelcomeRouteRouteChildren)

interface PrivateRouteRouteChildren {
  PrivateHomeRouteRoute: typeof PrivateHomeRouteRouteWithChildren
  PrivateWelcomeRouteRoute: typeof PrivateWelcomeRouteRouteWithChildren
}

const PrivateRouteRouteChildren: PrivateRouteRouteChildren = {
  PrivateHomeRouteRoute: PrivateHomeRouteRouteWithChildren,
  PrivateWelcomeRouteRoute: PrivateWelcomeRouteRouteWithChildren,
}

const PrivateRouteRouteWithChildren = PrivateRouteRoute._addFileChildren(
  PrivateRouteRouteChildren,
)

interface PublicAuthRouteRouteChildren {
  PublicAuthIndexRoute: typeof PublicAuthIndexRoute
}

const PublicAuthRouteRouteChildren: PublicAuthRouteRouteChildren = {
  PublicAuthIndexRoute: PublicAuthIndexRoute,
}

const PublicAuthRouteRouteWithChildren = PublicAuthRouteRoute._addFileChildren(
  PublicAuthRouteRouteChildren,
)

interface PublicRouteRouteChildren {
  PublicAuthRouteRoute: typeof PublicAuthRouteRouteWithChildren
}

const PublicRouteRouteChildren: PublicRouteRouteChildren = {
  PublicAuthRouteRoute: PublicAuthRouteRouteWithChildren,
}

const PublicRouteRouteWithChildren = PublicRouteRoute._addFileChildren(
  PublicRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  PrivateRouteRoute: PrivateRouteRouteWithChildren,
  PublicRouteRoute: PublicRouteRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
